import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate, stripHtml, estimateReadingTime } from '../../services/utils';

const FeaturedArticle = ({ article }) => {
  if (!article) return null;

  const excerpt = stripHtml(article.postExcerpt?.rendered || article.content?.rendered || '');
const readingTime = estimateReadingTime(article.content);

  return (
    <div className="relative bg-white rounded-lg shadow-lg overflow-hidden group">
      <div className="relative">
        {article.featured_media_url && (
          <div className="relative h-64 md:h-80 lg:h-96">
            <img
              src={article.featured_media_url}
              alt={article.title?.rendered || ''}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          </div>
        )}

        <div className="absolute top-4 left-4 z-10">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-600 text-white">
            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            À la une
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <div className="flex items-center space-x-4 mb-3">
            {article.categories && article.categories.length > 0 && (
              <Link
                to={`/category/${article.categories[0].slug}`}
                className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-blue-600 hover:bg-blue-700 transition-colors"
              >
                {article.categories[0].name}
              </Link>
            )}
            <div className="flex items-center text-sm opacity-90">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              {formatDate(article.date)}
            </div>
            <div className="flex items-center text-sm opacity-90">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12 6.253v13l-8-4.5v-13l8 4.5zm-6-1.5v11.5l6 3.375V7.753L6 4.753zm4 0V16.628l6-3.375V1.753L10 4.753z" clipRule="evenodd" />
              </svg>
              {readingTime} min de lecture
            </div>
          </div>
          
          <Link 
            to={`/article/${article.slug}`}
            className="block group-hover:text-blue-300 transition-colors"
          >
            <h1 
              className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 line-clamp-2 leading-tight"
              dangerouslySetInnerHTML={{ __html: article.title?.rendered || '' }}
            />
            <p className="text-lg opacity-90 line-clamp-3 leading-relaxed">
              {excerpt}
            </p>
          </Link>

          {article.author && (
            <div className="flex items-center mt-4 pt-4 border-t border-white/20">
              <div className="flex items-center">
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                  <span className="text-sm font-medium">
                    {article.author.name?.charAt(0) || 'A'}
                  </span>
                </div>
                <span className="ml-2 text-sm font-medium">
                  Par {article.author.name}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedArticle;